import { FC, memo, useContext, useState } from 'react'
import styles from './index.module.less'
import { ILoginFormProps } from './const'
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, UserOutlined } from '@ant-design/icons'
import globalContext from '~/contexts/global.context'
import { useLocation, useHistory } from 'react-router-dom'
import { api } from '~/request'
import { ECodeScene } from '~/enums/ECodeScene'
import { isMobilePhone } from '~/modules/@wmeimob/backend-pro/src/utils/validator'
import { Input, Button, Form } from 'antd'
import { encryptPassword } from '../../const'

const { Item, useForm } = Form

const Component: FC<ILoginFormProps> = (props) => {
  // 通过解构定义defaultProps
  // const {} = props

  const { dispatchAction } = useContext(globalContext)
  const { state } = useLocation<{ from?: string }>()
  const history = useHistory()
  const [form] = useForm()

  const [passwordType, setPasswordType] = useState('password')

  function handleFinish() {
    form.validateFields().then(async () => {
      const { mobile, password } = form.getFieldsValue()
      const encrypted = encryptPassword(password)

      const { data } = await api['/admin/auth/login_POST']({ mobile, password: encrypted, isStore: true })
      window.localStorage.setItem('Authorization', 'Bearer ' + (data || ''))
      await dispatchAction('getUserInfo')
      if (state && state.from) {
        history.replace(state.from)
      } else {
        history.replace('/')
      }
    })
  }

  return (
    <Form labelCol={{ span: 6 }} labelAlign="left" form={form} onFinish={handleFinish}>
      <Item
        name="mobile"
        validateFirst
        rules={[
          { required: true, message: '请输入手机号码' },
          { validator: (_, value) => (isMobilePhone(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的手机号码'))) }
        ]}
      >
        <Input placeholder="请输入手机号码" size="large" prefix={<UserOutlined style={{ color: '#bfbfbf' }} />} />
      </Item>
      <Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
        <Input
          placeholder="请输入密码"
          size="large"
          prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
          type={passwordType}
          suffix={
            passwordType === 'password' ? (
              <EyeInvisibleOutlined onClick={() => setPasswordType('text')} />
            ) : (
              <EyeOutlined onClick={() => setPasswordType('password')} />
            )
          }
        />
      </Item>

      <Form.Item noStyle>
        <div className={styles.opeartions}>
          <Button type="link" onClick={() => props.onClick(ECodeScene.FORGOT)}>
            忘记密码?
          </Button>
          <Button type="link" onClick={() => props.onClick(ECodeScene.REG)}>
            前往注册
          </Button>
        </div>
      </Form.Item>

      <Item>
        <Button type="primary" block size="large" htmlType="submit">
          登录
        </Button>
      </Item>
    </Form>
  )
}

Component.displayName = 'LoginForm'

const LoginForm = memo(Component)
export default LoginForm
